import React, { useEffect, useState } from 'react';
import API from '../utils/api';

export default function ReadingPassportWidget({ childId, childName }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!childId) return;
    setLoading(true);
    API.get(`/passport/${childId}`)
      .then(res => setData(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [childId]);

  if (loading) return (
    <div className="card border-0 shadow-sm rounded-4 p-4 mb-4">
      <div className="placeholder-glow"><div className="placeholder col-12 rounded" style={{ height: '120px' }}></div></div>
    </div>
  );

  if (!data?.grid) return null;

  const { grid, totalDaysActive, totalStoriesRead } = data;

  return (
    <div className="card border-0 shadow-sm rounded-4 p-4 mb-4" style={{ background: 'var(--card-bg)' }}>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <div>
          <h6 className="fw-bold mb-0" style={{ color: 'var(--text-main)', fontFamily: "'Fredoka One',cursive" }}>
            📅 {childName}'s Reading Passport
          </h6>
          <p className="text-muted small mb-0">{totalDaysActive} of 30 nights this month</p>
        </div>
        <div className="text-end">
          <div className="fw-bold" style={{ color: '#6f42c1', fontSize: '22px', fontFamily: "'Fredoka One',cursive" }}>{totalDaysActive}</div>
          <div className="text-muted" style={{ fontSize: '11px' }}>nights</div>
        </div>
      </div>

      {/* 30-day grid */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(10, 1fr)', gap: '4px' }}>
        {grid.map((day) => (
          <div
            key={day.date}
            title={`${day.date}${day.storiesRead > 0 ? ` — ${day.storiesRead} story` : ' — no story'}`}
            style={{
              aspectRatio: '1',
              borderRadius: '6px',
              background: day.hasActivity
                ? (day.isToday ? 'linear-gradient(135deg,#9b6fe8,#6f42c1)' : '#6f42c1')
                : (day.isToday ? 'var(--purple-section)' : 'var(--item-bg)'),
              border: day.isToday ? '2px solid #9b6fe8' : '1px solid var(--border-purple)',
              opacity: day.hasActivity ? 1 : 0.5,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '9px', color: day.hasActivity ? 'white' : 'var(--text-soft)',
              cursor: 'default',
              transition: 'transform 0.15s',
            }}
          >
            {day.hasActivity && day.storiesRead > 1 ? day.storiesRead : (day.hasActivity ? '★' : '')}
          </div>
        ))}
      </div>

      <div className="d-flex gap-3 mt-3">
        <div className="d-flex align-items-center gap-1">
          <div style={{ width: '12px', height: '12px', background: '#6f42c1', borderRadius: '3px' }}></div>
          <span className="text-muted" style={{ fontSize: '11px' }}>Story read</span>
        </div>
        <div className="d-flex align-items-center gap-1">
          <div style={{ width: '12px', height: '12px', background: 'var(--item-bg)', border: '1px solid var(--border-purple)', borderRadius: '3px', opacity: 0.5 }}></div>
          <span className="text-muted" style={{ fontSize: '11px' }}>No story</span>
        </div>
        <div className="ms-auto">
          <span className="small fw-semibold" style={{ color: '#6f42c1' }}>{totalStoriesRead} stories total</span>
        </div>
      </div>

      {/* Encouragement message */}
      {totalDaysActive >= 25 && (
        <div className="mt-3 p-2 rounded-3 text-center" style={{ background: 'var(--purple-section)', fontSize: '13px', color: '#6f42c1', fontWeight: 600 }}>
          🌟 Amazing! Nearly a perfect month!
        </div>
      )}
      {totalDaysActive >= 15 && totalDaysActive < 25 && (
        <div className="mt-3 p-2 rounded-3 text-center" style={{ background: 'var(--purple-section)', fontSize: '13px', color: '#6f42c1', fontWeight: 600 }}>
          ⭐ Great progress! Keep the streak going!
        </div>
      )}
    </div>
  );
}
